import { AlertService } from "../../services/alerts/service";
import { alertDataFromJson } from "../../domain/alerts/mapper";
import { alertRulesFromJson } from "../../domain/alerts/rules/mapper";
const alertService = new AlertService(alertDataFromJson, alertRulesFromJson, localStorage.getItem("basicUrl"));

const getDefaultState = () => {
  return {
    alertSettings: [],
    categories: [
      {
        id: null,
        name: "All",
        description: "Show all alerts",
        icon: "mdi-alert-circle",
        color: "error",
      },
      {
        id: 1,
        name: "Fouling",
        description: "Critical system notifications",
        icon: "mdi-sprout",
        color: "success",
      },
      {
        id: 2,
        name: "Engine",
        description: "Performance related issues",
        icon: "mdi-engine",
        color: "warning",
      },
      {
        id: 3,
        name: "Operation",
        description: "Scheduled maintenance notifications",
        icon: "mdi-factory",
        color: "info",
      },
      {
        id: 4,
        name: "Sensor Faults",
        description: "Scheduled maintenance notifications",
        icon: "mdi-leak-off",
        color: "warning",
      },
    ],
    selectedCategory: null,
    fetchLoading: true,
    fetchError: null,
    updateLoading: false,
    updateError: null,
    updateSuccess: false,
    updateFailed: false,
  };
};

const state = getDefaultState();

const getters = {
  filteredAlertSettings: (state) => {
    if (state.selectedCategory === null) {
      return state.alertSettings;
    }
    return state.alertSettings.filter((setting) => setting.alert.categoryId === state.selectedCategory);
  },
  fetchRequestFailed: (state) => (state.fetchError != null),
  updateRequestFailed: (state) => (state.updateError != null),
};

const actions = {
  async fetchAlerts({ commit }) {
    commit("SET_FETCH_LOADING_STATE");
    try {
      const alerts = await alertService.getRules(
        localStorage.getItem("quad_token"),
      );
      commit("SET_FETCH_SUCCESS_STATE", alerts);
    } catch (error) {
      commit("SET_FETCH_FAILED_STATE");
    }
  },

  async updateAlerts({ commit }, alertSetting) {
    commit("SET_UPDATE_LOADING_STATE");

    try {
      await alertService.updateManyFleet(
        localStorage.getItem("quad_token"),
        alertSetting.alert,
        alertSetting.applyToAllVessels
          ? alertSetting.alert.vessels
          : alertSetting.selectedVessels
      );

      commit("SET_UPDATE_SUCCESS_STATE");
    } catch (error) {
      commit("SET_UPDATE_FAILED_STATE");
    }
  }
};

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_ALL_CATEGORIES: (state, data) => (state.categories = data),
  SET_SELECTED_CATEGORY: (state, data) => (state.selectedCategory = data),
  SET_FETCH_LOADING_STATE(state) {
    state.fetchLoading = true;
    state.fetchError = null;
  },
  SET_FETCH_FAILED_STATE(state) {
    state.fetchLoading = false;
    state.fetchError = "Could not fetch alerts";
  },
  SET_FETCH_SUCCESS_STATE(state, data) {
    state.fetchLoading = false;
    state.fetchError = null;
    state.alertSettings = data.map((datum) => {
      return {
        alert: datum,
        selectedVessels: [],
        applyToAllVessels: false,
      };
    });
  },
  SET_UPDATE_LOADING_STATE(state) {
    state.updateLoading = true;
    state.updateError = null;
    state.updateSuccess = false;
    state.updateFailed = false;
  },
  SET_UPDATE_FAILED_STATE(state) {
    state.updateLoading = false;
    state.updateError = "Could not update alerts";

    state.updateSuccess = false;
    state.updateFailed = true;
  },
  SET_UPDATE_SUCCESS_STATE(state) {
    state.updateLoading = false;
    state.updateError = null;

    state.updateSuccess = true;
    state.updateFailed = false;
  }
};

export const fleetAlertsModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
